const VIEW_CONTAINER_SELECTOR = '[data-selector="employee-wrapper"]';
const TOGGLE_SELECTOR = '[data-selector="view-toggle"]';

let currentView: "grid" | "list" = "grid";

export const initEmployeesViewToggler = () => {
    const toggles = document.querySelectorAll<HTMLElement>(TOGGLE_SELECTOR);

    toggles.forEach((toggle) => {
        toggle.addEventListener("click", (event) => {
            const target = event.currentTarget as HTMLElement;
            const switchTo = target.getAttribute("data-switch") as
                | "grid"
                | "list";

            if (!switchTo) return;

            resetToggleStates(toggles);

            target.parentElement?.setAttribute("aria-active", "true");
            target.parentElement?.setAttribute("aria-disabled", "true");

            updateView(switchTo);
        });
    });
};

export const updateView = (viewType: "grid" | "list" = currentView) => {
    const viewContainer = document.querySelector<HTMLElement>(
        VIEW_CONTAINER_SELECTOR,
    );

    viewContainer?.setAttribute("data-view", viewType);

    currentView = viewType;
};

const resetToggleStates = (toggles: NodeListOf<HTMLElement>) => {
    toggles.forEach((el) => {
        el.parentElement?.setAttribute("aria-active", "false");
        el.parentElement?.setAttribute("aria-disabled", "false");
    });
};
